import { createSlice } from '@reduxjs/toolkit';
import {
  AllocationSummary,
  REUPLOAD_STATUS,
  ReUploadSummary
} from '../pages/AllocationServices/AllocationStatus/interface';

interface AllocationData {
  configData: Record<string, string>;
  selectedCycle: string;
  summaryData: AllocationSummary;
  reUploadSummaryData: ReUploadSummary;
}

const initialState: AllocationData = {
  configData: {},
  selectedCycle: '',
  summaryData: {
    allocationCycle: '',
    configName: '',
    allocationInitiatedAt: '',
    allocationCompletedAt: '',
    allocationRunType: '',
    allocationStatus: null,
    failureMeta: null,
    executionData: []
  },
  reUploadSummaryData: {
    workflowName: '',
    status: REUPLOAD_STATUS.INPROGRESS,
    createdAt: '',
    updatedAt: '',
    runMetrics: {
      totalRequiredRuns: 0,
      completed: 0,
      pending: 0,
      inProgress: 0,
      failed: 0,
      completionStatus: ''
    }
  }
};

export const allocationSlice = createSlice({
  name: 'allocationSlice',
  initialState,
  reducers: {
    setConfigData: (state, action) => {
      state.configData = action.payload;
    },
    setSelectedCycle: (state, action) => {
      state.selectedCycle = action.payload;
    },
    setSummaryData: (state, action) => {
      state.summaryData = action.payload;
    },
    setReUploadSummaryData: (state, action) => {
      state.reUploadSummaryData = action.payload;
    }
  }
});

export const { setConfigData, setSelectedCycle, setSummaryData, setReUploadSummaryData } =
  allocationSlice.actions;

export default allocationSlice.reducer;
